// extracted by mini-css-extract-plugin
export var content = "text-page-module--content--2iVNH";
export var pageTitle = "text-page-module--pageTitle--q91Yl";
export var introCopy = "text-page-module--introCopy--323O6";
export var body = "text-page-module--body--1Vi-2";